var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19157",
    "data-name": "Group 19157",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17558",
    "data-name": "Rectangle 17558",
    width: 17,
    height: 17,
    fill: "#4c4c4c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11210",
    "data-name": "Rectangle 11210",
    width: 25,
    height: 25,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20971",
    "data-name": "Group 20971",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20971-2",
    "data-name": "Group 20971",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35803",
    "data-name": "Path 35803",
    d: "M17,8.468V22.585a1.374,1.374,0,0,1-1.616,1.133H1.5c-.072,0-.144,0-.216,0a1.315,1.315,0,0,1-1.223-.927c-.021-.068-.041-.136-.061-.2V8.468A1.375,1.375,0,0,1,1.615,7.335H15.5c.072,0,.144,0,.216,0a1.31,1.31,0,0,1,1.223.927c.021.068.041.136.062.2M8.5,8.13H1.429C.988,8.13.8,8.323.8,8.768q0,6.759,0,13.518c0,.445.19.637.632.637H15.571c.444,0,.632-.19.632-.637q0-6.759,0-13.518c0-.446-.189-.636-.633-.637H8.5",
    transform: "translate(0 -7.01)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35804",
    "data-name": "Path 35804",
    d: "M51.626,74.884h-.943c-.406,0-.532-.127-.532-.537q0-.762,0-1.524V72.63H48.855c-.36,0-.5-.139-.5-.5q0-3.189,0-6.378c0-.361.143-.5.5-.5H60.576c.351,0,.5.143.5.491q0,3.2,0,6.394c0,.36-.142.5-.505.5H59.289c0,.065-.009.123-.009.181,0,.525,0,1.049,0,1.574,0,.361-.141.5-.5.5H57.8v.429c0,.243,0,.486,0,.729a.412.412,0,0,1-.46.461c-.194,0-.387,0-.581,0h-4.6c-.405,0-.538-.132-.538-.533,0-.353,0-.706,0-1.086m.8.811h4.583c0-.372,0-.73,0-1.089,0-.383.135-.517.518-.517h.957c0-.24,0-.459,0-.679,0-.381,0-.762,0-1.143a.4.4,0,0,1,.437-.43c.127,0,.255,0,.382,0h.963V66.051h-11.1v5.784h1.275c.364,0,.5.137.505.5,0,.525,0,1.049,0,1.574,0,.058.007.115.011.182.345,0,.67,0,1,0a.41.41,0,0,1,.468.467c0,.375,0,.751,0,1.139",
    transform: "translate(-46.214 -62.359)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35805",
    "data-name": "Path 35805",
    d: "M182.988,110.513c0-.314,0-.628,0-.943a.4.4,0,1,1,.8,0q0,.959,0,1.918a.4.4,0,1,1-.8,0c0-.325,0-.65,0-.976",
    transform: "translate(-174.887 -104.301)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35806",
    "data-name": "Path 35806",
    d: "M227.159,110.544c0-.325,0-.65,0-.975a.392.392,0,0,1,.387-.441.4.4,0,0,1,.408.441q0,.959,0,1.918a.4.4,0,1,1-.8,0c0-.314,0-.628,0-.942",
    transform: "translate(-217.102 -104.296)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35807",
    "data-name": "Path 35807",
    d: "M139.6,110.54c0,.32,0,.639,0,.959a.4.4,0,1,1-.8,0q0-.967,0-1.934a.4.4,0,0,1,.4-.433.39.39,0,0,1,.4.431c0,.325,0,.65,0,.975",
    transform: "translate(-132.66 -104.303)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35808",
    "data-name": "Path 35808",
    d: "M95.468,110.534c0,.32,0,.639,0,.959a.4.4,0,1,1-.794.008q-.006-.967,0-1.934a.4.4,0,0,1,.412-.436c.234.006.381.172.383.445,0,.32,0,.639,0,.959",
    transform: "translate(-90.479 -104.299)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35809",
    "data-name": "Path 35809",
    d: "M271.263,110.528c0-.32,0-.639,0-.959a.392.392,0,0,1,.386-.441.4.4,0,0,1,.408.44q.006.967,0,1.934a.4.4,0,0,1-.3.421.373.373,0,0,1-.428-.17.612.612,0,0,1-.063-.267c-.007-.319,0-.639,0-.959",
    transform: "translate(-259.252 -104.296)",
    fill: "#4c4c4c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWired);
export default __webpack_public_path__ + "static/media/wired.e8cc1b81092d73db48784dd00cee65d2.svg";
export { ForwardRef as ReactComponent };